import { render } from "./MarkdownViewer.vue?vue&type=template&id=34b68304&scoped=true"
import script from "./MarkdownViewer.vue?vue&type=script&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js"

import "./MarkdownViewer.vue?vue&type=style&index=0&id=34b68304&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b68304"]])

export default __exports__